import { render } from "./TableTemplate.vue?vue&type=template&id=4dc9fb23&scoped=true"
import script from "./TableTemplate.vue?vue&type=script&lang=js"
export * from "./TableTemplate.vue?vue&type=script&lang=js"

import "./TableTemplate.vue?vue&type=style&index=0&id=4dc9fb23&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc9fb23"]])

export default __exports__